import React, {useState} from 'react';
import {Button, Card, Modal, Tab, Tabs} from 'react-bootstrap';

import './WorkFlowInfoModal.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import ApiService from "../api/ApiService";
import {copyToClipboard} from "../utils/clipboardUtils";

const WorkFlowInfoModal = ({visible, flowId, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);

    const [activeTab, setActiveTab] = useState("inputData");

    const api =new ApiService();
    const [workflowInfo, setWorkflowInfo] = React.useState(null);
    React.useEffect(() => {
        if (!visible) return; // 如果不可见，则不执行后续逻辑

        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };
        if (flowId!=undefined){
            api.getWorkflowInfo(flowId).then(res => {
                if (res.code === 200) {
                    setWorkflowInfo(res.data);
                }
            })
        }

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [visible]); // 将 visible 添加到依赖数组中

    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '700px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                <span style={{color: '#060606', fontSize: '22px'}}>工作流详细信息</span>
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>
                <Tabs activeKey={activeTab} onSelect={(key) => setActiveTab(key)} variant={"tabs"} navbar={true} navbarScroll={true}
                      className="mb-1 custom-tabs">
                    <Tab eventKey={'inputData'} title={"输入参数详情"}>
                        <Card style={{border:'none'}}>
                            <Card.Header style={{display: 'flex', background:'#363B46', justifyContent: 'space-between', alignItems: 'center'}}>
                                <span style={{color:'#B4BFC5'}}>
                                <FontAwesomeIcon icon={faCode} style={{marginRight: '5px'}}/>输入参数结构
                                </span>
                                <Button
                                    onClick={() => {copyToClipboard(JSON.stringify(workflowInfo?.input))}}
                                    style={{background: '#02C8E3',color: '#1A1D23',fontWeight: 'bold',border: 'none',}} size={'sm'}>
                                    复制
                                </Button>
                            </Card.Header>
                            <Card.Body style={{background: '#2C313A',padding:0,}}>
                                 <pre style={{
                                     color: '#7E8385',
                                     fontSize: '14px',
                                     background: '#1E2129',
                                     padding: '10px',
                                     overflow: 'auto',
                                     maxHeight: '320px',
                                     lineHeight: 1.5,
                                     margin: 0,
                                 }}>
                                        {workflowInfo?.input && JSON.stringify(workflowInfo?.input, null, 2)}
                                 </pre>
                            </Card.Body>
                        </Card>

                    </Tab>
                    <Tab eventKey={'nodesInfos'} title={"节点信息详情"}>
                        <Card style={{border:'none',borderRadius: '4px'}}>
                            <Card.Header style={{display: 'flex', background:'#363B46', justifyContent: 'space-between', alignItems: 'center'}}>
                                <span style={{color:'#B4BFC5'}}>
                                <FontAwesomeIcon icon={faCode} style={{marginRight: '5px'}}/>节点信息结构
                                </span>
                                <Button
                                    onClick={() => {copyToClipboard(JSON.stringify(JSON.parse(workflowInfo?.content)))}}
                                    style={{background: '#02C8E3',color: '#1A1D23',fontWeight: 'bold',border: 'none',}} size={'sm'}>
                                    复制
                                </Button>
                            </Card.Header>
                            <Card.Body style={{background: '#2C313A',padding:0,}}>
                                <pre style={{color: '#7E8385', fontSize: '14px', background: '#1E2129', padding: '10px',
                                    overflow: 'auto',
                                    maxHeight: '320px',
                                    lineHeight: 1.5,
                                    margin: 0,}}>
                                    {workflowInfo?.content&&JSON.stringify(JSON.parse(workflowInfo?.content), null, 2)}
                                </pre>
                            </Card.Body>
                        </Card>

                    </Tab>
                    <Tab eventKey={'instructions'} title={"使用说明"}>
                        <div
                            style={{maxHeight: '400px', overflowY: 'auto', padding: '15px',color: '#7E8385'}}
                            dangerouslySetInnerHTML={{__html: workflowInfo?.instructions}}
                        />
                    </Tab>
                </Tabs>

            </Modal.Body>
        </Modal>

    );
};

export default WorkFlowInfoModal;